import { deepmerge } from '@mui/utils';
import { ApexOptions } from 'apexcharts';
import { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { formatPercent, ratio } from '../../HatUtils';
import { hatActionsFriendlyNames, HatMetricActionAttributionData } from '../dashboard/HatDbSectionActionAttribution';
import { HatDbChartCard } from './HatDbChartCard';
import { apexDonutChartOptionsFactory } from './HatDbVisualChannelAttributionPieChartCard';
import HatDbVisualSkeletonPieChart from './HatDbVisualSkeletonPieChart';

const defaultChartOptions = apexDonutChartOptionsFactory({
    totalLabel: 'Attributed Actions',
});

export function HatDbVisualActionAttributionPieChartCard(props: {
    currentData: HatMetricActionAttributionData;
    previousData: HatMetricActionAttributionData;
}) {
    const { currentData } = props;

    const chartOptions: ApexOptions = useMemo(() => {
        const slices = Object.entries(currentData)
            .filter((e) => e[0] !== 'total')
            .map((e) => ({
                label: hatActionsFriendlyNames[e[0]] ?? e[0],
                value: e[1].adInfluencedCount ?? 0,
            }))
            // Sort slices in descending order.
            .sort((a, b) => b.value - a.value);

        const total = currentData.total.adInfluencedCount ?? 0;

        return deepmerge(
            defaultChartOptions,
            {
                labels: slices.map(({ label }) => label),
                series: slices.map(({ value }) => value),
                tooltip: {
                    y: {
                        formatter: (value: number) => {
                            return formatPercent(ratio(value, total));
                        },
                    },
                },
            },
            {
                clone: true,
            }
        );
    }, [currentData]);

    const isPending = currentData.total.count === null;

    return (
        <HatDbChartCard>
            {isPending && <HatDbVisualSkeletonPieChart marginTop="60px" marginBottom="60px" />}

            {!isPending && <ReactApexChart type="donut" options={chartOptions} series={chartOptions.series} />}
        </HatDbChartCard>
    );
}
